var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 26.6664V37.3331C5.33301 42.6664 7.99967 45.3331 13.333 45.3331H17.1463C18.133 45.3331 19.1197 45.6264 19.973 46.1331L27.7597 51.0131C34.4797 55.2264 39.9997 52.1598 39.9997 44.2398V19.7598C39.9997 11.8131 34.4797 8.7731 27.7597 12.9864L19.973 17.8664C19.1197 18.3731 18.133 18.6664 17.1463 18.6664H13.333C7.99967 18.6664 5.33301 21.3331 5.33301 26.6664Z",
    fill: "#0A49A5",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 21.333C52.7467 27.653 52.7467 36.3463 48 42.6663",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8799 14.667C60.5865 24.9337 60.5865 39.067 52.8799 49.3337",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.9c5a3faefe8b67f6cb0f2d0274bf4e0b.svg";
export { ForwardRef as ReactComponent };